import Language from '@/entities/Language';

const LANGUAGES: Language[] = [
  {
    name: 'Afrikaans',
    code: 'af_za',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/a/af/Flag_of_South_Africa.svg',
  },
  {
    name: 'Albanian',
    code: 'sq',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/3/36/Flag_of_Albania.svg',
  },
  {
    name: 'Amharic',
    code: 'am',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/7/71/Flag_of_Ethiopia.svg',
  },
  {
    name: 'Arabic',
    code: 'ar_ar',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/2/2c/Flag_of_Saudi_Arabia.svg',
  },
  {
    name: 'Armenian',
    code: 'hy_am',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Flag_of_Armenia.svg',
  },
  {
    name: 'Azerbaijani',
    code: 'az',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/d/dd/Flag_of_Azerbaijan.svg',
  },
  {
    name: 'Belarusian',
    code: 'be_by',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/8/85/Flag_of_Belarus.svg',
  },
  {
    name: 'Bengali',
    code: 'bn_bn',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/f/f9/Flag_of_Bangladesh.svg',
  },
  {
    name: 'Bosnian (Bosnia and Herzegovina)',
    code: 'bs-ba',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/b/bf/Flag_of_Bosnia_and_Herzegovina.svg',
  },
  {
    name: 'Bulgarian',
    code: 'bg_bg',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/9/9a/Flag_of_Bulgaria.svg',
  },
  {
    name: 'Burmese',
    code: 'my_my',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/8/8c/Flag_of_Myanmar.svg',
  },
  {
    name: 'Catalan',
    code: 'ca_es',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/c/ce/Flag_of_Catalonia.svg',
  },
  {
    name: 'Croatian',
    code: 'hr_hr',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/1/1b/Flag_of_Croatia.svg',
  },
  {
    name: 'Czech',
    code: 'cs_cz',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/c/cb/Flag_of_the_Czech_Republic.svg',
  },
  {
    name: 'Danish',
    code: 'da_dk',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/9/9c/Flag_of_Denmark.svg',
  },
  {
    name: 'Dutch',
    code: 'nl_nl',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/2/20/Flag_of_the_Netherlands.svg',
  },
  {
    name: 'Dutch Belgium',
    code: 'nl_be',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/6/65/Flag_of_Belgium.svg',
  },
  {
    name: 'English',
    code: 'en_us',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/a/a4/Flag_of_the_United_States.svg',
  },
  {
    name: 'English (Australia)',
    code: 'en_au',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/b/b9/Flag_of_Australia.svg',
  },
  {
    name: 'English (Canada)',
    code: 'en_ca',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/c/cf/Flag_of_Canada.svg',
  },
  {
    name: 'English (India)',
    code: 'en_in',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_India.svg',
  },
  {
    name: 'English (Ireland)',
    code: 'en_ie',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/45/Flag_of_Ireland.svg',
  },
  {
    name: 'English (Switzerland)',
    code: 'en_ch',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/f/f3/Flag_of_Switzerland.svg',
  },
  {
    name: 'English (UK)',
    code: 'en_gb',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/8/83/Flag_of_the_United_Kingdom_%283-5%29.svg',
  },
  {
    name: 'Esperanto',
    code: 'eo',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/f/f5/Flag_of_Esperanto.svg',
  },
  {
    name: 'Estonian',
    code: 'et_ee',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/8/8f/Flag_of_Estonia.svg',
  },
  {
    name: 'Euskara',
    code: 'eu',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/2/2d/Flag_of_the_Basque_Country.svg',
  },
  {
    name: 'Farsi',
    code: 'fa_ir',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/c/ca/Flag_of_Iran.svg',
  },
  {
    name: 'Finnish',
    code: 'fi_fi',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/b/bc/Flag_of_Finland.svg',
  },
  {
    name: 'French',
    code: 'fr_fr',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/c/c3/Flag_of_France.svg',
  },
  {
    name: 'French (Canada)',
    code: 'fr_ca',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/c/cf/Flag_of_Canada.svg',
  },
  {
    name: 'French (Switzerland)',
    code: 'fr_ch',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/f/f3/Flag_of_Switzerland.svg',
  },
  {
    name: 'French Belgium',
    code: 'fr_be',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/6/65/Flag_of_Belgium.svg',
  },
  {
    name: 'Georgian',
    code: 'ka_ge',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/0/0f/Flag_of_Georgia.svg',
  },
  {
    name: 'German',
    code: 'de_de',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/b/ba/Flag_of_Germany.svg',
  },
  {
    name: 'German (Austria)',
    code: 'de_at',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_Austria.svg',
  },
  {
    name: 'German (Switzerland)',
    code: 'de_ch',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/f/f3/Flag_of_Switzerland.svg',
  },
  {
    name: 'Greek',
    code: 'el_gr',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_Greece.svg',
  },
  {
    name: 'Guarani',
    code: 'gn',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/0/04/Flag_of_Paraguay.svg',
  },
  {
    name: 'Gujarati',
    code: 'gu_in',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_India.svg',
  },
  {
    name: 'Haitian Creole',
    code: 'ht',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/5/56/Flag_of_Haiti.svg',
  },
  {
    name: 'Hawaiian',
    code: 'haw',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/e/ef/Flag_of_Hawaii.svg',
  },
  {
    name: 'Hebrew',
    code: 'he_il',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/d/d4/Flag_of_Israel.svg',
  },
  {
    name: 'Hindi',
    code: 'hi_in',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_India.svg',
  },
  {
    name: 'Hmong',
    code: 'hmn',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/6/62/Hmong_flag.svg',
  },
  {
    name: 'Hungarian',
    code: 'hu_hu',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/c/c1/Flag_of_Hungary.svg',
  },
  {
    name: 'Icelandic',
    code: 'is',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/c/ce/Flag_of_Iceland.svg',
  },
  {
    name: 'Indonesian',
    code: 'id_id',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/9/9f/Flag_of_Indonesia.svg',
  },
  {
    name: 'Italian',
    code: 'it_it',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/0/03/Flag_of_Italy.svg',
  },
  {
    name: 'Japanese',
    code: 'ja_jp',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/9/9e/Flag_of_Japan.svg',
  },
  {
    name: 'Kannada (India)',
    code: 'kn_in',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_India.svg',
  },
  {
    name: 'Kazakh',
    code: 'kk_kk',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/d/d3/Flag_of_Kazakhstan.svg',
  },
  {
    name: 'Khmer',
    code: 'km_kh',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/8/83/Flag_of_Cambodia.svg',
  },
  {
    name: 'Korean',
    code: 'ko_kr',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/0/09/Flag_of_South_Korea.svg',
  },
  {
    name: 'Kurdish',
    code: 'ku',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/3/35/Flag_of_Kurdistan.svg',
  },
  {
    name: 'Kyrgyz',
    code: 'ky',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/c/c7/Flag_of_Kyrgyzstan.svg',
  },
  {
    name: 'Latvian',
    code: 'lv_lv',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/8/84/Flag_of_Latvia.svg',
  },
  {
    name: 'Lithuanian',
    code: 'lt_lt',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/1/11/Flag_of_Lithuania.svg',
  },
  {
    name: 'Lao',
    code: 'lo',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/5/56/Flag_of_Laos.svg',
  },
  {
    name: 'Luxembourgish (French)',
    code: 'fr_lu',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/d/da/Flag_of_Luxembourg.svg',
  },
  {
    name: 'Luxembourgish (German)',
    code: 'de_lu',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/d/da/Flag_of_Luxembourg.svg',
  },
  {
    name: 'Macedonian',
    code: 'mk',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/f/f8/Flag_of_North_Macedonia.svg',
  },
  {
    name: 'Malagasy',
    code: 'mg_mg',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/b/bc/Flag_of_Madagascar.svg',
  },
  {
    name: 'Malay',
    code: 'ms_ms',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/6/66/Flag_of_Malaysia.svg',
  },
  {
    name: 'Malayalam',
    code: 'ml_ml',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/a/a6/Flag_of_Kerala.svg',
  },
  {
    name: 'Maori',
    code: 'mi',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/3/3e/Flag_of_New_Zealand.svg',
  },
  {
    name: 'Marathi',
    code: 'mr',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_India.svg',
  },
  {
    name: 'Mongolian',
    code: 'mn_mn',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/4c/Flag_of_Mongolia.svg',
  },
  {
    name: 'Ndebele',
    code: 'zu_nd',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/a/af/Flag_of_South_Africa.svg',
  },
  {
    name: 'Nepali',
    code: 'ne',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/9/9b/Flag_of_Nepal.svg',
  },
  {
    name: 'Norwegian',
    code: 'no_no',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/d/d9/Flag_of_Norway.svg',
  },
  {
    name: 'Pashto, Pushto',
    code: 'ps',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/2/20/Flag_of_Afghanistan.svg',
  },
  {
    name: 'Polish',
    code: 'pl_pl',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/1/12/Flag_of_Poland.svg',
  },
  {
    name: 'Portuguese (Portugal)',
    code: 'pt_pt',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_Portugal.svg',
  },
  {
    name: 'Portuguese (Brazil)',
    code: 'pt_br',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/0/05/Flag_of_Brazil.svg',
  },
  {
    name: 'Punjabi',
    code: 'pa',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_India.svg',
  },
  {
    name: 'Romanian',
    code: 'ro_ro',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/7/73/Flag_of_Romania.svg',
  },
  {
    name: 'Russian',
    code: 'ru_ru',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/f/f3/Flag_of_Russia.svg',
  },
  {
    name: 'Serbian (Cyrillic)',
    code: 'sr_sp',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/f/ff/Flag_of_Serbia.svg',
  },
  {
    name: 'Serbian (Latin)',
    code: 'sr_la',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/f/ff/Flag_of_Serbia.svg',
  },
  {
    name: 'Sesotho',
    code: 'st_st',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/4a/Flag_of_Lesotho.svg',
  },
  {
    name: 'Setswana',
    code: 'st_tn',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Flag_of_Botswana.svg',
  },
  {
    name: 'Shona',
    code: 'sn_sn',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/8/89/Flag_of_Zimbabwe.svg',
  },
  {
    name: 'Simplified Chinese',
    code: 'zh_cn',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Flag_of_the_People%27s_Republic_of_China.svg',
  },
  {
    name: 'Sinhala',
    code: 'si_lk',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/1/11/Flag_of_Sri_Lanka.svg',
  },
  {
    name: 'Slovak',
    code: 'sk_sk',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/e/e6/Flag_of_Slovakia.svg',
  },
  {
    name: 'Slovenian',
    code: 'sl_si',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/f/f0/Flag_of_Slovenia.svg',
  },
  {
    name: 'Somali',
    code: 'so',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/a/a0/Flag_of_Somalia.svg',
  },
  {
    name: 'Spanish',
    code: 'es_es',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/9/9a/Flag_of_Spain.svg',
  },
  {
    name: 'Spanish (Argentinian)',
    code: 'es_ar',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/1/1a/Flag_of_Argentina.svg',
  },
  {
    name: 'Spanish (Chile)',
    code: 'es_cl',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/7/78/Flag_of_Chile.svg',
  },
  {
    name: 'Spanish (Colombian)',
    code: 'es_co',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Colombia.svg',
  },
  {
    name: 'Spanish (Mexico)',
    code: 'es_mx',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/f/fc/Flag_of_Mexico.svg',
  },
  {
    name: 'Sudanese',
    code: 'sd',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/0/01/Flag_of_Sudan.svg',
  },
  {
    name: 'Swahili',
    code: 'sw',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/a/a2/Flag_of_Kenya.svg',
  },
  {
    name: 'Swedish',
    code: 'sv_se',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/4c/Flag_of_Sweden.svg',
  },
  {
    name: 'Tamil (India)',
    code: 'ta_in',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_India.svg',
  },
  {
    name: 'Tagalog',
    code: 'tl',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/9/99/Flag_of_the_Philippines.svg',
  },
  {
    name: 'Tajik',
    code: 'tg_tj',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/d/d0/Flag_of_Tajikistan.svg',
  },
  {
    name: 'Telugu',
    code: 'te_te',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_India.svg',
  },
  {
    name: 'Thai (Thailand)',
    code: 'th_th',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Flag_of_Thailand.svg',
  },
  {
    name: 'Tigrinya',
    code: 'ti',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/2/29/Flag_of_Eritrea.svg',
  },
  {
    name: 'Traditional Chinese',
    code: 'zh_tw',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/7/72/Flag_of_the_Republic_of_China.svg',
  },
  {
    name: 'Turkish',
    code: 'tr_tr',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/b/b4/Flag_of_Turkey.svg',
  },
  {
    name: 'Ukrainian',
    code: 'uk_ua',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/4/49/Flag_of_Ukraine.svg',
  },
  {
    name: 'Urdu',
    code: 'ur_pk',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/3/32/Flag_of_Pakistan.svg',
  },
  {
    name: 'Uzbek',
    code: 'uz',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/8/84/Flag_of_Uzbekistan.svg',
  },
  {
    name: 'Vietnamese',
    code: 'vi_vn',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Vietnam.svg',
  },
  {
    name: 'Welsh',
    code: 'cy_cy',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/d/dc/Flag_of_Wales.svg',
  },
  {
    name: 'Zulu',
    code: 'zu',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/a/af/Flag_of_South_Africa.svg',
  },
];

export default LANGUAGES;
